import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

function Sidebar({ user, onLogout }) {
    const env = localStorage.getItem('birt_environment') || 'staging';
    const region = localStorage.getItem('birt_region') || 'au';

    const envLabel = env === 'prod' ? 'PRODUCTION' : env === 'staging' ? 'STAGING' : 'DEVELOPMENT';
    const envClass = `env-badge-${env}`;
    const regionLabel = region === 'us' ? 'United States' : 'Australia';

    return (
        <div className="sidebar">
            <div className="sidebar-header">
                <div className="sidebar-brand">
                    BIRT
                </div>
                <div className="env-indicator">
                    <span className={`env-badge ${envClass}`}>{envLabel}</span>
                    <span className="env-region">{regionLabel}</span>
                </div>
            </div>

            <nav className="sidebar-nav">
                <NavLink to="/" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                    <svg className="nav-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
                    </svg>
                    <span className="nav-label">Dashboard</span>
                    <kbd className="nav-shortcut">⌘1</kbd>
                </NavLink>
                <NavLink to="/backup" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                    <svg className="nav-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="21 8 21 21 3 21 3 8"/><rect x="1" y="3" width="22" height="5"/><line x1="10" y1="12" x2="14" y2="12"/>
                    </svg>
                    <span className="nav-label">Backup</span>
                    <kbd className="nav-shortcut">⌘2</kbd>
                </NavLink>
                {/* Daily Backup nav hidden — backend feature live, page reachable via /daily-backups but not surfaced in sidebar yet.
                <NavLink to="/daily-backups" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                    <svg className="nav-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
                    </svg>
                    <span className="nav-label">Daily Backup</span>
                </NavLink>
                */}
                <NavLink to="/import" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                    <svg className="nav-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
                    </svg>
                    <span className="nav-label">Import</span>
                    <kbd className="nav-shortcut">⌘3</kbd>
                </NavLink>
                <NavLink to="/media-upload" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                    <svg className="nav-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
                    </svg>
                    <span className="nav-label">Media Upload</span>
                    <kbd className="nav-shortcut">⌘4</kbd>
                </NavLink>
                <NavLink to="/tasks" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                    <svg className="nav-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
                    </svg>
                    <span className="nav-label">Tasks</span>
                    <kbd className="nav-shortcut">⌘5</kbd>
                </NavLink>
                <NavLink to="/wipe" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                    <svg className="nav-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
                    </svg>
                    <span className="nav-label">Wipe Data</span>
                    <kbd className="nav-shortcut">⌘6</kbd>
                </NavLink>
                <NavLink to="/reset-cemetery" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                    <svg className="nav-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
                    </svg>
                    <span className="nav-label">Reset Cemetery</span>
                </NavLink>

                <div style={{ height: '20px' }}></div>

                {/* <NavLink to="/construction" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"} style={{ color: '#ff9800' }}>
                    <span className="nav-icon">🚧</span>
                    <span className="nav-label">Under Construction</span>
                </NavLink> */}
            </nav>

            <div className="sidebar-footer">
                <div className="footer-version">v1.1.0 (V4 Beta)</div>
            </div>
        </div>
    );
}

export default Sidebar;
